import BankItem from 'components/bankItem/BankItem';
import { FlexContainer } from 'components/pbl/PBL.styles';
import { PROGRESS } from 'config/config';
import { PaymentCategoryType } from 'consts';
import { getContainerHeight } from 'helpers/commonHelper';
import debounce from 'lodash/debounce';
import React, { createRef, PureComponent, RefObject } from 'react';
import withContext from '../../hoc/withContext';
import withTextContext from '../../hoc/withTextContext';

interface IProps extends IContext, IAccordionWrapper {
  paymentMethods: IMethod[];
}

interface ISelectedPaymentMethodId {
  selectedPaymentMethodId: string;
}

class PBL extends PureComponent<IProps, ISelectedPaymentMethodId> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  resize = debounce(() => {
    const { setHeight } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
  }, 200);

  componentDidMount() {
    const { setHeight } = this.props;

    setHeight(getContainerHeight(this.containerRef.current));
    window.addEventListener('resize', this.resize);
  }

  componentDidUpdate() {
    const { paymentMethods, setHeight, setProgress } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
    if (paymentMethods.some(method => !!method.preSelected)) {
      setProgress(PROGRESS.SELECT_PBL_BANK);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  handleClick = (id: string) => {
    const { setPaymentMethodAndProgressAndNotification, paymentMethods } = this.props;
    const selectedPayment = paymentMethods.find(i => i.id === id);
    let showPaymentNotification = false;
    let paymentMethodPType = 0;
    if (selectedPayment) {
      showPaymentNotification = selectedPayment.showPaymentNotification;
      paymentMethodPType = selectedPayment.pmpt;
    }
    setPaymentMethodAndProgressAndNotification(
      id,
      PaymentCategoryType.PBL,
      paymentMethodPType,
      showPaymentNotification,
      PROGRESS.SELECT_PBL_BANK
    );
  };

  render() {
    const { paymentMethods, isMobileOrTablet, paymentMethodId } = this.props;
    const isPreselected = paymentMethods.find(el => !!el.preSelected);

    return (
      <FlexContainer
        className={`pbl__container ${isPreselected ? 'pbl__container-preselected' : ''}`}
        ref={this.containerRef}
      >
        {paymentMethods.map((paymentMethod: IMethod) => (
          <BankItem
            key={paymentMethod.id}
            paymentMethod={paymentMethod}
            handleClick={this.handleClick}
            preSelected={!!paymentMethod.preSelected}
            isSelected={paymentMethodId === paymentMethod.id}
            isDisabled={paymentMethod.status === 'DISABLED'}
            isMobileOrTablet={isMobileOrTablet}
          />
        ))}
      </FlexContainer>
    );
  }
}

export default withContext(withTextContext(PBL));
